import { render, staticRenderFns } from "./EditBar.vue?vue&type=template&id=bb895284&"
import script from "./EditBar.vue?vue&type=script&lang=js&"
export * from "./EditBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports